'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ChartOverviewMyBorrowLoading } from '../ChartOverviewMyBorrow/states';
import { InfoMyPositionDataListLoading } from '../InfoMyPositionDataList/states';
import { MarketYourTransactionsLoading } from '../MarketYourTransactions/states';
const MarketYourPositionLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-xl flex w-[100%] flex-col"><InfoMyPositionDataListLoading /><ChartOverviewMyBorrowLoading /><MarketYourTransactionsLoading /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(MarketYourPositionLoading);